// 'use client'

// import { useState } from 'react'
// import { X, Mail, Lock, AlertCircle, Eye, EyeOff } from 'lucide-react'

// interface LoginModalProps {
//   isOpen: boolean
//   onClose: () => void
//   onLogin: (email: string, password: string) => Promise<void>
// }

// const LoginModal = ({ isOpen, onClose, onLogin }: LoginModalProps) => {
//   const [email, setEmail] = useState('')
//   const [password, setPassword] = useState('')
//   const [showPassword, setShowPassword] = useState(false)
//   const [isLoading, setIsLoading] = useState(false)
//   const [error, setError] = useState('')

//   const handleSubmit = async (e: React.FormEvent) => {
//     e.preventDefault()
//     setError('')
    
//     if (!email || !password) {
//       setError('Please enter both email and password')
//       return
//     }

//     setIsLoading(true)
//     try {
//       await onLogin(email, password)
//       // Reset form on successful login
//       setEmail('')
//       setPassword('')
//     } catch (err: any) {
//       setError(err.message || 'Login failed. Please try again.')
//     } finally {
//       setIsLoading(false)
//     }
//   }

//   if (!isOpen) return null

//   return (
//     <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-xl">
//         {/* Modal Header */}
//         <div className="bg-gradient-to-r from-primary to-primary-dark p-6">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <div className="size-12 rounded-xl bg-white/20 flex items-center justify-center backdrop-blur-sm">
//                 <span className="text-white font-bold text-xl">Y</span>
//               </div>
//               <div>
//                 <h2 className="text-xl font-bold text-white">Yaounde Urban Council</h2>
//                 <p className="text-white/80 text-sm">Taxi Registration System</p>
//               </div>
//             </div>
//             <button
//               onClick={onClose}
//               className="text-white/80 hover:text-white p-1"
//             >
//               <X size={24} />
//             </button>
//           </div>
//         </div>

//         {/* Modal Body */}
//         <div className="p-6">
//           <div className="mb-6">
//             <h3 className="text-lg font-bold text-slate-800">Administrator Login</h3>
//             <p className="text-slate-500 text-sm mt-1">
//               Enter your credentials to access the admin panel
//             </p>
//           </div>

//           <form onSubmit={handleSubmit} className="space-y-4">
//             {error && (
//               <div className="flex items-center gap-3 p-3 rounded-lg bg-red-50 border border-red-200 text-red-800 text-sm">
//                 <AlertCircle size={18} />
//                 <span className="font-medium">{error}</span>
//               </div>
//             )}

//             <div>
//               <label className="text-sm font-medium text-slate-700 mb-2 block">
//                 Email Address
//               </label>
//               <div className="relative">
//                 <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
//                   <Mail size={18} />
//                 </div>
//                 <input
//                   type="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
//                   placeholder="admin@urbancouncil.cm"
//                   disabled={isLoading}
//                 />
//               </div>
//             </div>

//             <div>
//               <label className="text-sm font-medium text-slate-700 mb-2 block">
//                 Password
//               </label>
//               <div className="relative">
//                 <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
//                   <Lock size={18} />
//                 </div>
//                 <input
//                   type={showPassword ? 'text' : 'password'}
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   className="w-full pl-10 pr-12 py-3 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
//                   placeholder="Enter your password"
//                   disabled={isLoading}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword(!showPassword)}
//                   className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
//                 >
//                   {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                 </button>
//               </div>
//             </div>

//             <div className="flex items-center justify-between text-sm">
//               <label className="flex items-center gap-2 cursor-pointer">
//                 <input
//                   type="checkbox"
//                   className="rounded border-slate-300 text-primary focus:ring-primary/20"
//                 />
//                 <span className="text-slate-600">Remember me</span>
//               </label>
//               <button type="button" className="text-primary hover:text-primary-dark font-medium">
//                 Forgot password?
//               </button>
//             </div>

//             <button
//               type="submit"
//               disabled={isLoading}
//               className="w-full rounded-lg bg-primary hover:bg-primary-dark text-white py-3 text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
//             >
//               {isLoading ? (
//                 <>
//                   <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
//                   Signing in...
//                 </>
//               ) : (
//                 'Sign In to Dashboard'
//               )}
//             </button>

//             <div className="pt-4 border-t border-slate-100">
//               <div className="text-center">
//                 <p className="text-xs text-slate-500">
//                   Contact support if you encounter any issues
//                 </p>
//                 <p className="text-xs text-slate-400 mt-1">
//                   support@urbancouncil.cm • +237 XXX XXX XXX
//                 </p>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default LoginModal

// components/LoginModal.tsx
// components/LoginModal.tsx
'use client'

import { useState, FormEvent } from 'react'
import { X, Mail, Lock, Eye, EyeOff } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import Image from 'next/image';

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginModal = ({ isOpen, onClose }: LoginModalProps) => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  
  const { login } = useAuth()

  const handleSubmit = async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault()
    
    if (!email || !password) {
      return;
    }

    console.log('Attempting login with:', { email, password })

    setIsLoading(true)
    try {
      await login(email, password)
      // Reset form on successful login
      setEmail('')
      setPassword('')
      if (onClose) onClose()
    } catch (err: any) {
      // Errors are now handled by the toast in AuthContext
      console.error('Login error:', err)
    } finally {
      setIsLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-xl">
        {/* Modal Header */}
        <div className="bg-gradient-to-r from-primary to-primary-dark p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Image
                src="/CUY.jpg"
                alt="Urban Council Logo"
                width={70}
                height={70}
                className="object-cover"
                priority
              />
              <div>
                <h2 className="text-xl font-bold text-white">Yaounde Urban Council</h2>
                <p className="text-white/80 text-sm">Taxi Registration System</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white/80 hover:text-white p-1"
            >
              <X size={24} />
            </button>
          </div>
        </div>

        {/* Modal Body */}
        <div className="p-6">
          <div className="mb-6">
            <h3 className="text-lg font-bold text-slate-800">Administrator Login</h3>
            <p className="text-slate-500 text-sm mt-1">
              Enter your credentials to access the admin panel
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-2 block">
                Email Address
              </label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                  <Mail size={18} />
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                  placeholder="admin@urbancouncil.cm"
                  disabled={isLoading}
                  required
                />
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-slate-700 mb-2 block">
                Password
              </label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                  <Lock size={18} />
                </div>
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full pl-10 pr-12 py-3 rounded-lg border border-slate-200 bg-white text-sm outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                  placeholder="Enter your password"
                  disabled={isLoading}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600"
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between text-sm">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  className="rounded border-slate-300 text-primary focus:ring-primary/20"
                />
                <span className="text-slate-600">Remember me</span>
              </label>
              <button type="button" className="text-primary hover:text-primary-dark font-medium">
                Forgot password?
              </button>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full rounded-lg bg-primary hover:bg-primary-dark text-white py-3 text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <div className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                  Signing in...
                </>
              ) : (
                'Sign In to Dashboard'
              )}
            </button>

            <div className="pt-4 border-t border-slate-100">
              <div className="text-center">
                <p className="text-xs text-slate-500">
                  Contact support if you encounter any issues
                </p>
                <p className="text-xs text-slate-400 mt-1">
                  support@urbancouncil.cm • +237 XXX XXX XXX
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginModal